import {
  ComponentRef,
  Injectable,
  OnInit,
  Type,
  ViewContainerRef
} from '@angular/core';
import { LMAdHocSearchComponent, LMFormComponent, LMListComponent, LMPageComponent } from '@app/components';
import { LMOverlayInfo, LMOverlayService, LMFlyoutContentEvent } from '@app/services';
import { Subscription } from 'rxjs';

@Injectable()
export class LMComponentInjectorService {
  private rootViewContainer: ViewContainerRef | undefined;
  private component: ComponentRef<LMFormComponent> | ComponentRef<LMListComponent> | ComponentRef<LMPageComponent> | ComponentRef<LMAdHocSearchComponent> | undefined;
  private flyoutContentEventsSubscription: Subscription | undefined;

  constructor(private lmOverlayService: LMOverlayService) {}

  public setRootViewContainerRef(viewContainerRef: ViewContainerRef) {
    this.rootViewContainer = viewContainerRef;
  }

  public addFormComponent(url: string): LMFormComponent | undefined {
    if (this.rootViewContainer) {
      this.component = this.rootViewContainer.createComponent(LMFormComponent);
      this.rootViewContainer.insert(this.component.hostView);
      this.component.instance.overlayUrl = url;
      this.component.instance.isInOverlay = true;
      this.component.instance.topLevelOverlayComponent = true;
      return this.component.instance;
    }
  }

  public addListComponent(url: string): LMListComponent | undefined {
    if (this.rootViewContainer) {
      this.component = this.rootViewContainer.createComponent(LMListComponent);
      this.rootViewContainer.insert(this.component.hostView);
      this.component.instance.overlayUrl = url;
      this.component.instance.topLevelOverlayComponent = true;
      return this.component.instance;
    }
  }

  public addPageComponent(url: string): LMPageComponent | undefined {
    if (this.rootViewContainer) {
      this.component = this.rootViewContainer.createComponent(LMPageComponent);
      this.rootViewContainer.insert(this.component.hostView);
      return this.component.instance;
    }
  }

  public addAdhocSearchComponent(overlayInfo: LMOverlayInfo): LMAdHocSearchComponent | undefined {
    if (this.rootViewContainer) {
      this.component = this.rootViewContainer.createComponent(LMAdHocSearchComponent);
      this.rootViewContainer.insert(this.component.hostView);
      this.component.instance.overlayInfo = overlayInfo;
      return this.component.instance;
    }
  }

  public addCustomComponent(component: Type<any>, inputs?: Record<string, any>): any | undefined {
    if (this.rootViewContainer) {
      const componentRef = this.rootViewContainer.createComponent(component);
      if (componentRef && componentRef.instance) {
        this.rootViewContainer.insert(componentRef.hostView);
        this.component = componentRef;

        // Set inputs on the component instance
        if (inputs) {
          for (const [key, value] of Object.entries(inputs)) {
            (componentRef.instance as any)[key] = value;
          }
        }

        // Check for flyoutContentEvents Observable and subscribe
        if (componentRef.instance.flyoutContentEvents && typeof componentRef.instance.flyoutContentEvents.subscribe === 'function') {
          this.flyoutContentEventsSubscription = componentRef.instance.flyoutContentEvents.subscribe(
            (event: LMFlyoutContentEvent) => {
              this.lmOverlayService.emitFlyoutContentEvent(event);
            }
          );
        }

        return componentRef.instance;
      }
    }
  }

  public destroyComponent(): void {
    if (this.flyoutContentEventsSubscription) {
      this.flyoutContentEventsSubscription.unsubscribe();
      this.flyoutContentEventsSubscription = undefined;
    }
    if (this.rootViewContainer && this.component) {
      this.rootViewContainer.detach();
      this.component.destroy();
    }
  }
}
